import { Checkbox, Dialog, Typography } from "@mui/material";

import React, { useState } from "react";
import { Close, ErrorOutline } from "@mui/icons-material";
import CustomButton from "../../../reusableComponents/CustomButton";
import ConflictRule from "../../../../assets/svg/routing/conflictRule.svg";

function ConflictRuleModal({ isOpen, setIsOpen, }) {


    const handleKeyDownFallback = (event) => {
        if (event.key === "Escape") {
            setIsOpen(false);
        }
    };


    return (
        <Dialog
            open={isOpen}
            PaperProps={{
                style: {
                    borderRadius: "12px",
                    maxWidth: "700px",
                },
            }}
            onKeyDown={handleKeyDownFallback}
        >
            <div className="">
                <div
                    className="d-flex align-items-start w-100 justify-content-between"
                    style={{ padding: "24px 24px 0px 24px" }}
                >
                    <div
                        className="d-flex align-items-start  justify-content-start"
                        style={{ gap: 10 }}
                    >
                        <ErrorOutline style={{ color: "#F53535" }} />
                        <Typography
                            sx={{
                                color: "#1D1C20",
                                fontWeight: 500,
                            }}
                        >
                            Conflicting Rules
                        </Typography>
                    </div>
                    <Close
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsOpen(false)}
                    />
                </div>
                <hr />

                <div className="px-4">
                    <Typography
                        sx={{
                            fontSize: "14px",
                            fontWeight: 400,
                            color: "#2D2B32",
                            letterSpacing: "-0.2px",
                            marginBottom: "10px"
                        }}>
                        A rule with same name or conditions already exists, preventing the creation of the rule. Please review them and try again.                                    </Typography>

                    <ConflictRule />
                </div>
            </div>

            <div className="modalBottomBar mt-3">
                <CustomButton
                    text={"Ok, got it"}
                    onClick={() => setIsOpen(false)}
                    variant={"contained"}
                    type={"secondary"}
                />

            </div>
        </Dialog>
    );
}

export default ConflictRuleModal;
